"use client";
import { Box, type SxProps } from "@mui/material";
import type React from "react";
import { FOOTER_HEIGHT } from "@/config/constants";
import { Version } from "./utilities/Version";

interface FooterProps {
	sx?: SxProps;
}

export function Footer({ sx }: FooterProps): React.ReactElement {
	const version = import.meta.env.VITE_APP_VERSION_HASH;

	return (
		<Box
			component={"footer"}
			sx={{
				gridArea: "footer",
				height: FOOTER_HEIGHT,
				py: 1,
				px: 2,
				display: "flex",
				justifyContent: "right",
				backgroundColor: (theme) =>
					theme.palette.mode === "light" ? theme.palette.grey[200] : theme.palette.grey[800],
				...sx,
			}}
		>
			<Version version={version || "N/A"} />
		</Box>
	);
}
